/**
 * @prettier
 */

import { createContext } from 'react';

export const Context = createContext<{
	homePageTab: number;
	updateHomePageTab: (newTab: number) => void;
}>({
	homePageTab: 1,
	updateHomePageTab: (_newTab: number) => {}
});
